/*
 * @Description: 帮助中心
 * @Author: Harry
 * @Date: 2020-12-28 16:25:29
 * @LastEditTime: 2020-12-29 11:38:16
 * @LastEditors: Harry
 */
import i18n from "@/locales";

export default [
  // {
  //   path: "/help-center",
  //   name: "help-center",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import("@/views/help-center/List.vue"),
  //   meta: {
  //     showHeader: true,
  //     title: i18n.t("help_center.nav_title")
  //   }
  // },
  {
    path: "/help-center/detail/:id",
    name: "help-center-detail",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("@/views/help-center/Detail.vue"),
    meta: {
      showHeader: true
    }
  },
  {
    path: "/help-center/activation-email",
    name: "help-center-activation-email",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("@/views/help-center/ActivationEmail.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("help_center.list[1].text")
    }
  },
  {
    path: "/help-center/mainland-account-open",
    name: "help-center-mainland-account-open",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("@/views/help-center/MainlandAccountOpen.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("help_center.list[0].text")
    }
  }
];
